export default "__VITE_ASSET__ANYznuDa__"